import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import './styles/App.css';
import { instance } from './common';
import Pc_TopTitle from './Pc_TopTitle';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

function ModalPage({modal, toggle, Comp}){
    
    
    const mheight = {
        minHeight: '60vh'
    }

    return (
 

        <Modal isOpen={modal} toggle={toggle}>

        
            <ModalHeader toggle={toggle} className="text-center Pc_modalHeader" id="writeTitle">

            </ModalHeader>
        
            <ModalBody className="" style={mheight}>
                <Pc_Progress />
            </ModalBody>
 
       </Modal>


        
    )
}

function allremove(u_login_id,u_type){
    let obj;
    let whereField;
    if(u_type == '일반고객'){
        obj = {represent:0}
        whereField ='u_id';
    }else if(u_type == '카마스터'){
        obj = {represent2:0}
        whereField ='u_id2';
    }
    
    let valueObj = {
        obj:obj,
        whereField:whereField,
        whereValue:u_login_id
    }

    const fetchData = async () => {
        instance.post('/rep_car/update',valueObj).then(function(res){
            var size = document.getElementsByName("repre_car").length;
    
            for(var i = 0; i < size; i++){
                if(document.getElementsByName("repre_car")[i].checked == true){
                    let obj;
                    if(u_type == '일반고객'){
                        obj = {represent:1}
                    }else if(u_type == '카마스터'){
                        obj = {represent2:1}
                    }
                    let valueObj = {
                        obj:obj,
                        whereField:'rep_id',
                        whereValue:document.getElementsByName("repre_car")[i].dataset.id
                    }
                    const fetchData = async () => {
                        instance.post('/rep_car/update',valueObj).then(function(res){
                            alert('대표차량이 변경되었습니다.');
                        });
                        
                    };
                
                    fetchData();
                }
            }
        });
        
    };

    fetchData();
}

function Pc_Progress_Real({ goPage, history }) {
    const [modal, setModal] = useState(false);
    const toggle = (e) => {
        const { name } = e.target.dataset;
        setModal(!modal);
        
    }


    const myinfo = JSON.parse(window.sessionStorage.result);
    const { u_login_id, u_nick, u_type, u_dealer_agency } = myinfo;
    let field;
    let represent;
    if (u_type === '일반고객' || u_type === '총판' || u_type === '클라이언트' || u_type === '시공지점') {
        field = 'c.co_user_id';
        represent = 'rep.represent';
    } else if (u_type == '카마스터') {
        field = 'c.co_user_id2';
        represent = 'rep.represent2';
    }
    const [data, setData] = useState([]);
    const [data2, setData2] = useState('-');
    let obj = {
        u_id: u_login_id,
        field: field,
        represent: represent
    }
    useEffect(() => {

        const fetchData = async () => {
            instance.post('/rep_car/main_info', obj).then(function (res) {
                console.log('data is: ', res.data);
                setData(res.data);
            });

        };

        fetchData();

    }, []);

    console.log('data2 : ', data2)
    const [isRep ,setRep] = useState(false);
    const mySize = {
        marginTop: "30px",
        marginBottom: "30px"
    }
    const setRepre = () => {
        if(isRep){
            allremove(u_login_id,u_type);

        }else{
            alert('차량이 존재하지 않습니다.');
        }

    }

    let isTitle = "차량리스트"
    return (

        <Container style={mySize}>
            {
                data.length !== 0
                    ?
                    data.map(v => <Row key={v.rep_id}>
                        <Col className="p-0">
                            <Pc_TopTitle title={isTitle} />
 
                            <div className="thisCartTitleBox pt-4 row pl-0 pr-0">
                                <div className="col-10 text-center sangTitleText">차량정보</div>
                                <div className="col-2 p-0 text-center pb-4 sangTitleText">
                                    <span className="sangTitleText">대표차량</span>
                                </div>
                                <div className="col-10 pb-4 pt-4 border-top">
                                    <p className="font-weight-bold modelTextPro">모델명 : {v.u_car_name}<div onClick={toggle} className="text-primary float-right pointer d-inline-block">차량 진행상태</div></p>
                                    <div className="otherTExtPro">차량번호 :   {
                                        u_type == '일반고객'
                                            ? v.u_car_number
                                            : <span>-</span>
                                    }</div>
                                    <div className="otherTExtPro">차량 APP 등록일 : {v.u_app_date}</div>
                                    <div className="otherTExtPro">연식 : {v.u_car_age}</div>
                                    <div className="otherTExtPro">출고일 : {v.u_car_date}</div>
                                    <div className="otherTExtPro">출고색상 : {v.u_car_color}</div>
                                </div>
                                <div class="col-2 pb-4 border-left text-center border-top pt-4">
                                    {
                                        u_type == "일반고객"
                                            ? v.represent == 1
                                                ? <input type="radio" name="repre_car" data-id={v.rep_id} checked />
                                                : <input type="radio" name="repre_car" data-id={v.rep_id} />
                                            : v.represent2 == 1
                                                ? <input type="radio" name="repre_car" data-id={v.rep_id} checked />
                                                : <input type="radio" name="repre_car" data-id={v.rep_id} />
                                    }
                                </div>

                            </div>


                        </Col>
                    </Row>)
                    :
                    <Row>
                        <Col className="p-0">
                        <Pc_TopTitle title={isTitle} />
                            <div className="thisCartTitleBox pt-4 row pl-0 pr-0">
                                <div className="col-10 text-center sangTitleText">차량정보</div>
                                <div className="col-2 p-0 text-center pb-4 sangTitleText">
                                    <span className="sangTitleText">대표차량</span>
                                </div>
                                <div className="col-10 pb-4 pt-4 border-top">
                                    <p className="font-weight-bold modelTextPro">모델명 : - <div onClick={toggle} className="text-primary float-right pointer d-inline-block">차량 진행상태</div></p>
                                    <div className="otherTExtPro">차량번호 :   {
                                        u_type == '일반고객'
                                        ? <span>-</span>
                                        : <span>-</span>
                                    }</div>
                                    <div className="otherTExtPro">차량 APP 등록일 :  - </div>
                                    <div className="otherTExtPro">연식 : - </div>
                                    <div className="otherTExtPro">출고일 : - </div>
                                    <div className="otherTExtPro">출고색상 : - </div>
                                </div>
                                <div class="col-2 pb-4 border-left text-center border-top pt-4">
                                    
                                </div>

                            </div>
                            

                        </Col>
                    </Row>
            }
            <ModalPage toggle={toggle} modal={modal} />

        </Container>
    )
}



function Pc_Progress() {

    const myinfo = JSON.parse(window.sessionStorage.result);
    // console.log('myinfo  : ', myinfo);
    const { u_login_id, u_car_name, u_car_number, u_car_date, u_type } = myinfo;
    const obj = myinfo;
    //loadReseve(u_car_number);

    const [data, setData] = useState([]);

    const [before, setBefore] = useState([]);
    const [after, setAfter] = useState([]);

    useEffect(() => {
        let u_field;
        let rep_field;
        if (u_type == '카마스터') {
            u_field = 'u_id2';
            rep_field = 'represent2';
        } else if (u_type == '일반고객') {
            u_field = 'u_id';
            rep_field = 'represent';
        }
        let obj = {
            u_field: u_field,
            u_id: u_login_id,
            rep_field: rep_field,
        }
        const fetchData = async () => {
            instance.post('/rep_car/status', obj).then(function (res) {
                console.log('res : ',)
                setData(res.data[0]);
                if (res.data.length !== 0) {
                    setBefore(JSON.parse(res.data[0].photo_before))
                    setAfter(JSON.parse(res.data[0].photo_after))
                }

            });

        };

        fetchData();

    }, []);

    console.log('data : ', data)

    const circle = {
        width: '8px',
        height: '8px',
        borderRadius: '90px',
        position: 'absolute',
        background: '#ddd',
        left: '-3px'
    }

    const second = {
        top: '123px'
    }
    const third = {
        top: '370px'
    }

    const blueBg = {
        background: '#06f'
    }

    const variWidth = {
        //height: data.r_enddate ? '290px' :  data.r_gumsu ? '100px' : '0px'

    }
    return (
        <>
            {
                data
                    ?
                    <Container className="">
                        <Row className="d-block" style={{ marginBottom: '30px' }}>
                            <div className="p_wrapLine">

                                <div className="wrap_status_pc" id="statusbar" style={{ background: '#ddd' }}>
                                    {!data.r_ipgo ? <span style={circle}></span> : <span style={{ ...circle, ...blueBg }}></span>}
                                    {!data.r_gumsu ? <span style={{ ...circle, ...second }}></span> : <span style={{ ...circle, ...second, ...blueBg }}></span>}
                                    {!data.r_enddate ? <span style={{ ...circle, ...third }}></span> : <span style={{ ...circle, ...third, ...blueBg }}></span>}
                                </div>
                                <div className="statusbarAtive" id="" style={{ background: '#06f', ...variWidth }}></div>
                                <div>
                                    <h3 className="font-weight-bold mt-5 mb-4">진행상태</h3>
                                    <div>
                                        <h4 className="font-weight-bold mb-0 ml-4" id="start">{!data.r_ipgo ? <span className="StatusTitlepro">차량입고</span> : <span className="StatusTitlepro">차량입고 완료</span>}</h4>
                                        <span className="text-muted ml-4" id="reserve_complete">{data.r_ipgo}</span>
                                        <span className="text-muted" id="start2"> </span>
                                    </div>
                                    <h4 className="font-weight-bold mb-0 ml-4 p_midSection" id="check">{!data.r_gumsu ? <span className="StatusTitlepro">검수</span> : <span className="StatusTitlepro">검수 완료</span>}</h4>
                                    <span className="text-muted ml-4" id="gumsu_complete">{data.r_gumsu}</span>
                                    <span className="text-muted" id="check2"> </span>
                                    <div className="div-overflow-wrap">
                                        <div className="p_wrapMid ml-4 mt-3">
                                            {
                                                before.length != 0
                                                    ?
                                                    before.map(v => <div className="p_midimg mr-4" style={{ background: 'url(\'' + v + '\')' }}></div>)
                                                    : <div></div>
                                            }
                                        </div>
                                    </div>
                                    <h4 className="font-weight-bold mb-0 ml-4 p_botSection" id="finish">{!data.r_enddate ? <span  className="StatusTitlepro">작업</span> : <span  className="StatusTitlepro">작업 완료</span>}</h4>
                                    <span className="text-muted ml-4" id="work_complete">{data.r_enddate}</span>
                                    <span className="text-muted" id="finish2"> </span>
                                </div>
                            </div>
                        </Row>
                    </Container>
                    :
                    <Container className="">
                        <Row className="d-block" style={{ marginBottom: '30px' }}>
                            <div className="p_wrapLine">

                                <div className="wrap_status_pc" id="statusbar" style={{ background: '#ddd' }}>
                                    <span style={{ ...circle }}></span>
                                    <span style={{ ...circle, ...second }}></span>
                                    <span style={{ ...circle, ...third }}></span>
                                </div>
                                <div className="statusbarAtive" id="" style={{ background: '#06f', ...variWidth }}></div>
                                <div>
                                    <h3 className="font-weight-bold mt-5 mb-4">진행상태</h3>
                                    <div>
                                        <h4 className="font-weight-bold mb-0 ml-4" id="start"><span>차량입고</span></h4>
                                        <span className="text-muted ml-4" id="reserve_complete"></span>
                                        <span className="text-muted" id="start2"> </span>
                                    </div>
                                    <h4 className="font-weight-bold mb-0 ml-4 p_midSection" id="check"><span>검수</span></h4>
                                    <span className="text-muted ml-4" id="gumsu_complete"></span>
                                    <span className="text-muted" id="check2"> </span>
                                    <div className="div-overflow-wrap">
                                        <div className="p_wrapMid ml-4 mt-3">
                                        </div>
                                    </div>
                                    <h4 className="font-weight-bold mb-0 ml-4 p_botSection" id="finish"><span>작업</span> </h4>
                                    <span className="text-muted ml-4" id="work_complete"></span>
                                    <span className="text-muted" id="finish2"> </span>
                                </div>
                            </div>
                        </Row>
                    </Container>
            }

        </>
    );
}

function loadReseve(r_car_number) {
    instance.post('/reserve/same-number', {
        r_car_number: r_car_number
    })
        .then(function (response) {
            // handle success
            const data = response.data;

            if (data.length !== 0) {
                let str = '';
                data.forEach(v => {
                    console.log("v.r_status : ", v.r_status);
                    if (v.r_status == '입고완료') {
                        document.getElementById('reserve_complete').innerHTML = v.r_reserve_date;
                        document.getElementById('start').innerHTML = ' ' + v.r_status;
                        document.getElementById('start2').innerHTML = ' ' + v.r_status;
                        str += '<div class="progress">\
                        <div class="progress-bar" role="progressbar" style="width: 100%; height:10% " aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>\
                      </div>';
                    } else if (v.r_status == '검수완료') {
                        document.getElementById('gumsu_complete').innerHTML = v.r_gumsu;
                        document.getElementById('check').innerHTML = ' ' + v.r_status;
                        document.getElementById('check2').innerHTML = ' ' + v.r_status;
                        str += '<div class="progress">\
                        <div class="progress-bar" role="progressbar" style="width: 100%; height:50% " aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>\
                      </div>';
                    } else if (v.r_status == '작업완료') {
                        document.getElementById('work_complete').innerHTML = v.r_enddate;
                        document.getElementById('finish').innerHTML = v.r_status;
                        document.getElementById('finish2').innerHTML = ' ' + v.r_status;
                        str += '<div class="progress">\
                        <div class="progress-bar" role="progressbar" style="width: 100%; height:100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>\
                      </div>';
                    }

                    document.getElementById('statusbar').innerHTML = str;

                });


            }
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
}

export default Pc_Progress_Real;